import { inject, Pipe, PipeTransform } from '@angular/core';
import { USER } from '@marmon/frontend/common';
import { AlgoliaAnalysis } from '@marmon/shared/types/analysis';
import { isAdmin } from '@marmon/shared/types/user';

@Pipe({
	standalone: true,
	name: 'canEditAnalysis',
})
export class CanEditAnalysisPipe implements PipeTransform {
	readonly user$ = inject(USER);

	transform(analysis: AlgoliaAnalysis) {
		const user = this.user$.value;
		if (!user) return false;

		// admins can edit all analyses
		if (isAdmin(user)) return true;

		// users can edit their own analyses
		return user.id === analysis.createdById;
	}
}
